import React from 'react'

const PageContactForm = ({ slice }) => {
    return (
        <section className="page-contact-form">
            <div className="center-small">
                <div className="contact-form">
                    <h2 className="text-blue">GET IN TOUCH</h2>
                    <p>*Indicates a required field</p>
                    <form name={slice.primary.form_name.text} method="post" data-netlify="true" data-netlify-honeypot="bot-field">
                        <p>
                            <input type="hidden" name="form-name" value="contact" />
                        </p>
                        <p>
                            <label>YOUR NAME* <input type="text" name="name" placeholder="John Galloping Dog"/></label>   
                        </p>
                        <p>
                            <label>EMAIL ADDRESS* <input type="email" name="email" placeholder="John@joingallopingdog.com"/></label>
                        </p>
                        <p>
                            <label>PHONE NUMBER <input type="tel" name="phone" placeholder="555-555-5555"/></label>
                        </p>
                        <p>
                            <label>YOUR MESSAGE* <textarea name="message"></textarea></label>
                        </p>
                        <p>
                            <button type="submit" className="button-red">Submit form</button>
                        </p>
                    </form>
                </div>
            </div>
        </section>
    )
}

export default PageContactForm